import * as z from "zod";

export const generateProductBarcode = {
  name: "generateProductBarcode" as const,
  input: z.object({}),
  output: z.object({ barcode: z.string() }),
};
